import { ResponsiveValue } from "@chakra-ui/styled-system";
import { ValueAnimationTransition } from "framer-motion";

interface ConceivePlan {
  text: string;
  highlightColor: string;
}

export interface PageState {
  progress: number;
  text: string;
  plan?: ConceivePlan[];
  arrow?: boolean;
  highlight?: boolean;
  duration: number;
  transitionDuration: ResponsiveValue<string>;
  transitionStyle: ValueAnimationTransition;
}

export const pageStates: PageState[] = [
  {
    progress: 0,
    text: "Thanks for sharing",
    duration: 1600,
    transitionDuration: "0.2",
    transitionStyle: { type: "tween", ease: "easeOut" },
  },
  {
    progress: 0,
    text: "We're looking at your responses",
    duration: 1600,
    transitionDuration: "0.2",
    transitionStyle: { type: "tween", ease: "easeOut" },
  },
  {
    progress: 0,
    text: "And working on your personalized plan",
    duration: 800,
    transitionDuration: "0.2",
    transitionStyle: { type: "tween", ease: "easeOut" },
  },
  {
    progress: 0,
    text: "And working on your personalized plan",
    plan: [],
    duration: 800,
    transitionDuration: "0.2",
    transitionStyle: { type: "tween", ease: "easeOut" },
  },
  {
    progress: 0,
    text: "And working on your personalized plan",
    plan: [
      {
        text: "24/7 fertility and pregnancy coaching",
        highlightColor: "#BECCFF",
      },
    ],
    duration: 200,
    transitionDuration: "0.2",
    transitionStyle: { type: "tween", ease: "easeOut" },
  },
  {
    progress: 33,
    text: "And working on your personalized plan",
    plan: [
      {
        text: "24/7 fertility and pregnancy coaching",
        highlightColor: "#BECCFF",
      },
    ],
    duration: 800,
    transitionDuration: "0.6",
    transitionStyle: { type: "tween", ease: "easeOut" },
  },
  {
    progress: 33,
    text: "And working on your personalized plan",
    plan: [
      {
        text: "24/7 fertility and pregnancy coaching",
        highlightColor: "#BECCFF",
      },
      {
        text: "Weekly evidence-based tips",
        highlightColor: "#FFE1A2",
      },
    ],
    duration: 200,
    transitionDuration: "0.2",
    transitionStyle: { type: "tween", ease: "easeOut" },
  },
  {
    progress: 66,
    text: "And working on your personalized plan",
    plan: [
      {
        text: "24/7 fertility and pregnancy coaching",
        highlightColor: "#BECCFF",
      },
      {
        text: "Weekly evidence-based tips",
        highlightColor: "#FFE1A2",
      },
    ],
    duration: 800,
    transitionDuration: "0.6",
    transitionStyle: { type: "tween", ease: "easeOut" },
  },
  {
    progress: 66,
    text: "And working on your personalized plan",
    plan: [
      {
        text: "24/7 fertility and pregnancy coaching",
        highlightColor: "#BECCFF",
      },
      {
        text: "Weekly evidence-based tips",
        highlightColor: "#FFE1A2",
      },
      {
        text: "A community that gets it",
        highlightColor: "#FFC3BF",
      },
    ],
    duration: 200,
    transitionDuration: "0.2",
    transitionStyle: { type: "tween", ease: "easeOut" },
  },
  {
    progress: 100,
    text: "And working on your personalized plan",
    plan: [
      {
        text: "24/7 fertility and pregnancy coaching",
        highlightColor: "#BECCFF",
      },
      {
        text: "Weekly evidence-based tips",
        highlightColor: "#FFE1A2",
      },
      {
        text: "A community that gets it",
        highlightColor: "#FFC3BF",
      },
    ],
    duration: 800,
    transitionDuration: "0.6",
    transitionStyle: { type: "tween", ease: "easeOut" },
  },
  {
    progress: 100,
    text: "All set",
    plan: [
      {
        text: "24/7 fertility and pregnancy coaching",
        highlightColor: "#BECCFF",
      },
      {
        text: "Weekly evidence-based tips",
        highlightColor: "#FFE1A2",
      },
      {
        text: "A community that gets it",
        highlightColor: "#FFC3BF",
      },
    ],
    duration: 200,
    arrow: true,
    transitionDuration: "0.2",
    transitionStyle: { type: "tween", ease: "easeOut" },
  },
  {
    progress: 100,
    text: "All set",
    plan: [
      {
        text: "24/7 fertility and pregnancy coaching",
        highlightColor: "#BECCFF",
      },
      {
        text: "Weekly evidence-based tips",
        highlightColor: "#FFE1A2",
      },
      {
        text: "A community that gets it",
        highlightColor: "#FFC3BF",
      },
    ],
    duration: 800,
    arrow: true,
    highlight: true,
    transitionDuration: "1.4",
    transitionStyle: { type: "tween", ease: "easeOut" },
  },
];
